import { render } from "./StateBadge.vue?vue&type=template&id=52737184"
import script from "./StateBadge.vue?vue&type=script&lang=js"
export * from "./StateBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__